import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface JsonViewerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  /** Raw JSON string (or any text). Will be pretty-printed if parseable. */
  content: string;
}

export function JsonViewerDialog({
  open,
  onOpenChange,
  title,
  content,
}: JsonViewerDialogProps) {
  const pretty = (() => {
    if (!content) return '';
    try {
      return JSON.stringify(JSON.parse(content), null, 2);
    } catch {
      return content;
    }
  })();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <pre className="max-h-[60vh] overflow-auto rounded-md border border-border bg-muted/40 p-3 font-mono text-xs">
          {pretty || <span className="text-muted-foreground">(empty)</span>}
        </pre>
      </DialogContent>
    </Dialog>
  );
}
